import { render, staticRenderFns } from "./s.vue?vue&type=template&id=3fc8d4fc&"
import script from "./s.vue?vue&type=script&lang=js&"
export * from "./s.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports